import { Modal } from '../Modal/Modal';

export const ApplicationUpdated = () => {
  const applicationUpdatedTitle = 'Your application needs to reload';
  const applicationUpdateSubtitle = 'Notification';
  const applicationUpdatedContent =
    'To apply the latest updates and features, your application needs to reload. Please click the button below to refresh and continue using the app with the latest updates to your application.';

  const modalButtons = {
    rtl: true,
    primaryButton: {
      name: 'reloadPage',
      children: 'Reload page',
      onClick: () => window.location.reload(),
    },
  };

  const modalProps = {
    buttonGroupPresModel: modalButtons,
    showClose: false,
    subtitle: applicationUpdateSubtitle,
    title: applicationUpdatedTitle,
  };

  return <Modal {...modalProps}>{applicationUpdatedContent}</Modal>;
};
